/* fs-holiday.js (Oct 27 2026, Deputy build, STAGED + DORMANT)
   Quick add-to-cart for the holiday product cards. One delegated click handler, so cards that are
   inserted later (the VIP sale reveals its products after the code) work too.
   Adds ONE unit of ONE variant through /cart/add.js. Never starts checkout. */
(function () {
  if (window.__fshAddLoaded) return;
  window.__fshAddLoaded = true;

  function openCart() {
    try {
      // Rebuy Smart Cart: show the drawer if it has loaded. Otherwise the "View cart" link under the button is the fallback.
      if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') { Rebuy.SmartCart.show(); return true; }
    } catch (e) {}
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fsh-add]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var card = btn.closest('.fsh-card');
    var label = btn.getAttribute('data-label') || 'Add to cart';
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'add failed');
      btn.textContent = 'Added';
      btn.disabled = false;
      if (card) card.classList.add('is-added');
      var live = document.querySelector('[data-fsh-live]');
      if (live) live.textContent = (btn.getAttribute('data-name') || 'Item') + ' added to your cart.';
      document.dispatchEvent(new CustomEvent('fsh:added', { detail: { variantId: id } }));
      openCart();
      setTimeout(function () { btn.textContent = label; }, 2500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = 'Could not add. Tap to try again';
      if (window.console) console.warn('[fsh] add to cart failed:', err && err.message);
    });
  });
})();
